import { createSelector } from 'reselect';

export const getDisplayedProducts = createSelector(
  [({ searchAndBrowse } = {}) => searchAndBrowse],
  ({ displayedProducts = 0 } = {}) => displayedProducts,
);
